const listeners = {};

export const onNativeEvent = (event, handler) => {
  if (!listeners[event]) listeners[event] = new Set();
  listeners[event].add(handler);
  return () => listeners[event].delete(handler);
};

export const emitNativeEvent = (event, payload) => {
  if (!listeners[event]) return;
  listeners[event].forEach((fn) => fn(payload));
};
